/**
 * /tenants/$slug/posture/compliance/reports/$kind — a document report's
 * page. `?run=` names the run on screen; without it the page shows the
 * newest ready run of the kind.
 */

import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { fetchReports } from "@/features/compliance/queries";
import { queryKeys } from "@/lib/query-keys";
import { MandateReportPage } from "@/features/compliance/pages/mandate-report-page";

const searchSchema = z.object({
  // The run on screen. A stale or hand-edited id renders the newest run
  // with a note, never a route error.
  run: z.string().uuid().optional().catch(undefined),
});

export const Route = createFileRoute(
  "/_authed/tenants/$slug/posture/compliance/reports/$kind",
)({
  validateSearch: searchSchema,
  loader: ({ context }) =>
    context.queryClient.ensureQueryData({
      queryKey: queryKeys.compliance.reports(context.tenant.id),
      queryFn: () => fetchReports(context.tenant.id),
    }),
  component: MandateReportPage,
});
